module.exports = __webpack_public_path__ + "media/images/flags/az-ffc25d95190ee9888213146b777b023c.svg";